import React, { useState } from 'react';
import Header from '../utils/Header'
import Footer from '../utils/Footer'
import nosotros from '../../assets/nosotros.png'

const ListingReserved = () => {


  return (
    <div >
      <Header />
      <div className="max-w-2xl mx-auto bg-white p-6 rounded-2xl shadow-md text-primaryP font-poppins">
        <h2 className="text-2xl font-bold text-center mb-4">¿Cómo funciona LetoH?</h2>
        <p className="text-center mb-6">
          Con nuestro equipo especializado nos encargamos de todos los detalles del proceso. 
          Cuenta con nosotros para que alquilar tu propiedad sea una experiencia tranquila y sin complicaciones.
        </p>

        <div className="space-y-6">
          <div className="flex flex-col items-center">
            <img src={nosotros} alt="Icono" className="w-12 h-12 mb-4" />
            <div className="bg-[#FBF3F0] p-4 rounded-lg shadow">
              Nos encargamos de preparar la propiedad, administrar los listados, manejar reservas, 
              check-ins/check-outs y asistir a los huéspedes 24/7 durante sus estadías, brindando un servicio 
              de HOTEL de alta calidad.
            </div>
          </div>

          <div className="flex flex-col items-center">
            <img src={nosotros} alt="Icono" className="w-12 h-12 mb-4" />
            <div className="bg-[#FBF3F0] p-4 rounded-lg shadow">
              Utilizamos tecnología e inteligencia de marketing para promocionar su propiedad, 
              garantizando una rentabilidad mucho mayor que el alquiler tradicional.
            </div>
          </div>

          <div className="flex flex-col items-center">
            <img src={nosotros} alt="Icono" className="w-12 h-12 mb-4" />
            <div className="bg-[#FBF3F0] p-4 rounded-lg shadow">
              Ofrecemos una experiencia espectacular a nuestros huéspedes, lo que se traduce en 
              críticas positivas y más reservas.
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ListingReserved;


